import { Link, useNavigate, useParams } from 'react-router-dom'
import { Table, useApiQuery, type Column } from 'grabbitbot-legacy-ui'
import { screenerClient } from '../../api'
import type { CoinPairList } from '../../api/types'

/** Equivalent of legacy `CoinpairlistListComponent` (audit §3/§6). */
export function CoinpairlistListPage() {
  const { exchangeId = '', tradingType = '' } = useParams<{ exchangeId: string; tradingType: string }>()
  const navigate = useNavigate()
  const { data, loading, error, refetch } = useApiQuery(
    () => screenerClient.searchCoinpairlists(exchangeId, tradingType),
    [exchangeId, tradingType],
  )

  async function remove(id: string) {
    await screenerClient.deleteCoinpairlist(exchangeId, tradingType, id)
    refetch()
  }

  const columns: Column<CoinPairList>[] = [
    {
      key: 'name',
      label: 'Name',
      align: 'left',
      format: (_v, row) => <Link to={`/${exchangeId}/${tradingType}/coinpairlists/${row.id}`}>{row.name}</Link>,
    },
    { key: 'coinPairs', label: 'Coin pairs', align: 'left', format: (v) => (Array.isArray(v) ? v.length : 0) },
    {
      key: 'id',
      label: '',
      sortable: false,
      format: (_v, row) => (
        <button type="button" onClick={() => row.id && remove(row.id)}>
          Delete
        </button>
      ),
    },
  ]

  return (
    <div>
      <div className="screener-page-title">
        <h1>
          Coin-pair lists <small>({exchangeId} · {tradingType})</small>
        </h1>
        <button type="button" onClick={() => navigate(`/${exchangeId}/${tradingType}/coinpairlists/new`)}>
          New list
        </button>
      </div>
      {loading && <p>Loading…</p>}
      {error && <p role="alert">Could not load coin-pair lists.</p>}
      {data && <Table columns={columns} rows={data} rowKey={(row, i) => row.id ?? i} initialSort={{ key: 'name', dir: 'asc' }} />}
    </div>
  )
}
